<ph-dialog [open]="open" size="sm" heading="Select Your Bank" (ph-close)="closeDialog()">
    <ph-stack>
        <ph-stack align="center">
            <img alt="bank icon" src="/assets/images/payhoa/dashboardEmpty/bank.svg"/>
        </ph-stack>
        <ph-input [formControl]="institutionSearchControl"
                  ngDefaultControl
                  name="search"
                  aria-label="Search by bank name"
                  placeholder="Search by bank name..."
                  (keyup.enter)="cancelEvent($event)"></ph-input>
        <ph-scroll-area *ngIf="institutions.length" max-height="300px">
            <ph-action-list [items]="institutionItems" (ph-select)="selectInstitutionById($event.detail)"></ph-action-list>
        </ph-scroll-area>
    </ph-stack>

    <ph-actions *ngIf="preferencesLoaded && product === 'auth'" slot="footer">
        <ng-container *ngIf="manualAddEnabled">
            <span>Can't find your bank?</span>
            <ph-button variant="secondary" mode="filled" aria-label="Add account manually" (click)="selectInstitution(null)">Add it with account and routing numbers &raquo;</ph-button>
        </ng-container>
        <span *ngIf="!manualAddEnabled">Can't find your bank? Please contact PayHOA to enable manual account linking.</span>
    </ph-actions>
</ph-dialog>
